import { useQuery } from '@tanstack/react-query';
import { LinearBuyingLambdaFetch, awaitJSON } from '../../utils/fetch-utils';
import { OrderRow } from './linear-orders-constants';

export const linearOrdersQueryKey = (company: string, week: string) => [
  'linearOrders',
  company,
  week
];

export const useLinearOrders = (
  company: string,
  week: string
): ReturnType<typeof useQuery<OrderRow[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: linearOrdersQueryKey(company, week),
    enabled: Boolean(company),
    queryFn: async (): Promise<OrderRow[]> => {
      const res = await LinearBuyingLambdaFetch('/getOrdersAndTraffic', {
        params: { company, week }
      });
      return awaitJSON<OrderRow[]>(res);
    }
  });
